import AbstractNormalizersResolver from "../../core/AbstractNormalizersResolver";
import SelectItemNormalizer from "./SelectItemNormalizer";
export default class SelectItemNormalizersResolver extends AbstractNormalizersResolver {
    register() {
        return [
            new SelectItemNormalizer(),
        ];
    }
}
